import React, { useContext, useState} from 'react';
import { TextField,  IconButton, Grid, Tooltip, Box, Typography } from '@mui/material';
//import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { useArticles } from '../contexts/ArticlesContext'; // Adjust the import according to your project structure
import algoliasearch from 'algoliasearch/lite';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PublicIcon from '@mui/icons-material/Public';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/algolia/SVG/Algolia-logo-blue.svg';  // Add this import
import { FeedbackContext } from '../contexts/FeedbackContext'; // Add this import


// Initialize the client with your Application ID and Search-Only API Key
const searchClient = algoliasearch('AR76SEY721', '51e86cf54ec8720f6ab05af76be8c2cf');

// Initialize the specific index you want to search
const index = searchClient.initIndex('The Climate Spectrum');

const SearchControls = ({ }) => {
    const { inputValue, setInputValue, handleReset, fetchArticlesByIds } = useArticles();
    const { showFeedback } = useContext(FeedbackContext);
    const [anchorEl, setAnchorEl] = useState(null);



    const handleSearchClick = async () => {
        if (!inputValue?.trim()) {
            showFeedback('Please enter a search term', 'info');
            return;
        }
    
        try {
            // Add search options to handle potential null values
            const { hits } = await index.search(inputValue, {
                attributesToRetrieve: ['objectID'],
                removeWordsIfNoResults: 'none'
            });
    
            // Validate hits array
            if (!Array.isArray(hits)) {
                console.error('Invalid hits structure:', hits);
                showFeedback('Error processing search results', 'error');
                return;
            }
    
            const objectIDs = hits
                .filter(hit => hit && hit.objectID) // Filter out invalid hits
                .map(hit => hit.objectID);
    
            if (objectIDs.length === 0) {
                showFeedback('No articles found matching your search criteria', 'info');
                return;
            }
    
            // Log successful search for debugging
            console.log(`Found ${objectIDs.length} matching articles`);
            await fetchArticlesByIds(objectIDs);
            
        } catch (error) {
            console.error('Error in search process:', error);
            showFeedback('Error searching articles', 'error');
        }
    };

    // if (inputValue) {
    //     fetchSearchResults();
    //}

    const handleSubmit = (event) => {
        event.preventDefault();
        handleSearchClick();
    };

    // const handleMenuOpen = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const handleMenuClose = () => {
    //     setAnchorEl(null);
    // };

    return (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <Grid
                container
                spacing={1}
                alignItems="center"
                sx={{
                    width: '100%',
                    margin: '0 auto',
                    padding: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '4px',
                    minHeight: '48px'
                }}
            >
                {/* Search TextField */}
                <Grid item xs={7} sm={9} md={10}>
                    <TextField
                        label="Search Articles"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        fullWidth
                        size="small"
                        InputProps={{
                            endAdornment: (
                                <Box
                                    sx={{
                                        display: { xs: 'none', md: 'flex' }, // Hide on mobile, show on md and up
                                        alignItems: 'center',
                                        gap: 1,
                                        opacity: 0.7,
                                        paddingRight: 1
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: 'text.secondary',
                                            fontSize: '0.75rem',
                                        width: 'auto',
                                        }}
                                    >
                                    Search by
                                    </Typography>
                                    <Logo 
                                        style={{
                                            height: '16px',
                                            width: 'auto'
                                        }}
                                    />
                                </Box>
                            )
                        }}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '4px',
                            '& .MuiOutlinedInput-root': {
                                height: '40px'
                            }
                        }}
                    />
                </Grid>

                {/* Action Buttons Container */}
                <Grid
                    item
                    xs={5} sm={3} md={2}
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    alignItems="center"
                >
                    {/* Search Button */}
                    <Grid item>
                        <IconButton
                            type="submit"
                            color="primary"
                            size="small"
                            sx={{
                                backgroundColor: 'primary.main',
                                height: '32px',
                                width: '32px',
                                '&:hover': {
                                    backgroundColor: 'primary.dark'
                                }
                            }}
                        >
                            <SearchIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </Grid>

                    {/* Reset Button */}
                    <Grid item>
                        <IconButton
                            onClick={handleReset}
                            color="secondary"
                            size="small"
                            sx={{
                                backgroundColor: 'secondary.main',
                                height: '32px',
                                width: '32px',
                                '&:hover': {
                                    backgroundColor: 'secondary.dark'
                                }
                            }}
                        >
                            <ClearIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </Grid>

                    {/* Globe Button */}
                    <Grid item>
                        <Tooltip title="Go to Globe View" arrow>
                            <IconButton
                                component={Link}
                                to="/"
                                size="small"
                                sx={{
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    height: '32px',
                                    width: '32px',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.2)'
                                    },
                                    color: 'white'
                                }}
                            >
                                <PublicIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

export default SearchControls;